import { effectScope, onScopeDispose, EffectScope } from "vue";

export const useSharedComposable = <Args extends unknown[], R extends ReturnType<() => unknown>>(
  composable: (...args: Args) => R
): ((...args: Args) => R) => {
  let subscribers = 0;
  let state: R | undefined;
  let scope: EffectScope | undefined;

  const dispose = () => {
    subscribers -= 1;
    if (scope && subscribers <= 0) {
      scope.stop();
      state = undefined;
      scope = undefined;
    }
  };

  return (...args: Args) => {
    subscribers += 1;
    if (!state) {
      scope = effectScope(true);
      state = scope.run(() => composable(...args))!;
    }

    onScopeDispose(dispose);
    return state;
  };
};
